import useABTestValue from '@hooks/useABTestValue'

const useIsFmtRelevantMatchesEnabled = () =>
  useABTestValue('relevantMatchesOnSportHome') === 'show'

export default useIsFmtRelevantMatchesEnabled
